<template>
    <div
        @mouseenter="showClipboardIcon"
        @mouseleave="hideClipboardIcon"
        @click="copyField()"
        class="cursor-copy flex items-center"
    >
        <slot></slot>
        <CopyClipboardSVG
            v-if="visibleClipboard"
            :fill="clipboardFill"
            class="w-4 h-4 ml-0.5 pb-0.5"
        />
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import { useClipboard } from '@vueuse/core'
import CopyClipboardSVG from '@/components/svg-components/CopyClipboardSVG.vue';

const props = defineProps(['copySource'])

const visibleClipboard = ref(false)
const clipboardFill = ref('')
const source = ref(props.copySource ? props.copySource : '')
const { text, copy, copied, isSupported } = useClipboard({ source })

function copyField() {
    highlightClipboard()
    copy(source.value)
    setTimeout(() => {
        unHighlightClipboard()
    }, 75)

}

function showClipboardIcon() {
    visibleClipboard.value = true
}

function hideClipboardIcon() {
    visibleClipboard.value = false
}

function highlightClipboard() {
    clipboardFill.value = '#000'
}

function unHighlightClipboard() {
    clipboardFill.value = '#FFF'
}
</script>